import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { DeleteFromShuffleRequest } from '../api/mytunes/deletefromshuffle/deletefromshufflerequest';
import { DeleteFromShuffleResponse, DeleteFromShuffleResponseDtoImpl } from '../api/mytunes/deletefromshuffle/deletefromshuffleresponse';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { Strings } from '../../utils/resources/strings';

export class DeleteFromShuffleAPIProcessorImpl extends SixdeeCRBTAPIProcessor<DeleteFromShuffleRequest, DeleteFromShuffleResponse>
{
    execute(request: DeleteFromShuffleRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try 
        {
            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
             {
                let response = new DeleteFromShuffleResponseDtoImpl(APIFeatures.DELETE_FROM_SHUFFLE, "Delete From Shuffle Success");

                this.getAPISuccess(response);
            }
        }
        catch (e)
        {
            this.getAPIFailure(new DeleteFromShuffleResponseDtoImpl(APIFeatures.DELETE_FROM_SHUFFLE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
       this.getAPIFailure(new DeleteFromShuffleResponseDtoImpl(APIFeatures.DELETE_FROM_SHUFFLE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/deletefromshuffleapiprocessor.tsx